import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";



const LoadingBackDrop = () => {
    return (
        <Modal aria-labelledby="loading" open={true} sx={{ zIndex: '9999' }}  >
            <Box sx={{ display: "grid", placeItems: "center", width: "100%", height: "100vh" }}>
                <Box>
                    <div className="loading__backdrop"></div>
                    <Typography color="primary.contrastText" sx={{ fontSize: 17 }}>
                        กำลังโหลด
                    </Typography>
                </Box>
            </Box>
        </Modal>
    );
};

export default LoadingBackDrop;
